//import $ from 'jquery';

window.$ = $;
console.log($);
$(document).ready(function() {
    //images
    document.querySelectorAll('img').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `image ${index}`);
        currentValue.setAttribute('pardot-region-type', "image");
    });
    //h tag
    document.querySelectorAll('h1,h2,h3,h4,h5').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `title ${index}`);
        currentValue.setAttribute('pardot-region-type', "basic");
    });
    //text
    document.querySelectorAll('p').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `text ${index}`);
        currentValue.setAttribute('pardot-region-type', "basic");
    });
    //phone
    document.querySelectorAll('p').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `text ${index}`);
        currentValue.setAttribute('pardot-region-type', "basic");
    });
    //footer terms
    document.querySelectorAll('.footer .terms').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `link ${index}`);
        currentValue.setAttribute('pardot-region-type', "basic");
    });
    //footer language dropdown label
    document.querySelectorAll('#link_lang1').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `language label ${index}`);
        currentValue.setAttribute('pardot-region-type', "basic");
    });
    //footer language dropdown
    document.querySelectorAll('.footer .dropdown-menu a').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `language ${index}`);
        currentValue.setAttribute('pardot-region-type', "link");
    });
    //footer social icon
    document.querySelectorAll('.footer .social a').forEach((currentValue, index) => {
        currentValue.setAttribute('pardot-region', `social ${index}`);
        currentValue.setAttribute('pardot-region-type', "link");
    });
    //button
    document.querySelectorAll('button').forEach((currentValue, index) => {
        currentValue.parentElement.setAttribute('pardot-region', `button ${index}`);
        currentValue.parentElement.setAttribute('pardot-region-type', "html");
    });
    document.querySelectorAll('.thank-you-page .thumbnail-outter a').forEach((currentValue, index) => {
        currentValue.parentElement.setAttribute('pardot-region', `redirect ${index}`);
        currentValue.parentElement.setAttribute('pardot-region-type', "html");
    });

});


$('#videoModal').on('hidden.bs.modal', function () {
    console.log("hide");
    $("#videoModal iframe").attr("src", $("#videoModal iframe").attr("src"));
});



